import { Box, Grid, Grid2, IconButton, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import TextFieldComponent from "../../../../../Components/TextFieldComponent";
import DropdownComponent from "../../../../../Components/DropdownComponent";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import EmailIcon from "@mui/icons-material/Email";
import { LabelWithCheckbox } from "../../../../../Components/Ui_elements/LabelWithCheckbox";
import { LabelWithIcons } from "../../../../../Components/Ui_elements/LabelWithIcons";
import dayjs from "dayjs";
import { Email, Person, Person2 } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import EmailClient from "../../../../Admin/A_System/Templates/EmailClient";
import Btn from "../../../../../Components/Ui_elements/Btn";
import PopupModal from "../../../../../Components/Ui_elements/PopupModal";
import { getEmailTemplate } from "../../../../../redux/Thunk/InvoiceModule/InvoiceThunk";
import { sendClientMessage } from "../../../../../redux/Thunk/authThunk/login";
import { useNavigate } from "react-router-dom";
import DatePickerComponent from "../../../../../Components/DatePickerComponent";
import { formatDateTime } from "../../../../../Components/formateDate";
import TimePickerComponent from "../../../../../Components/TimePickerComponent";
import { format } from "date-fns";

const Form = ({
  id,
  projectDetail,
  masterDropdownList,
  formData,
  selectedScoopTemplateId,
  handleInputChange,
  handleTemplateChange,
  errors,
  scoopTemplateOptions,
  clientsOption,
  usermanagerOptions,
  clientContactOptions,
  coordinatorOptions,
  isClientSelected,
  setOpenContactModal,
  setOpenAccountModal,
  accountOptions,
  qaOptions,
  specializationOptions,
  handleSave,
  abbrevationCode,
}) => {
  const {
    // client_view_direct_data,
    // client_payment_list,
    // client_login_detail_list,
    // client_view_direct_contact,

    client_all_data,
  } = useSelector(state => state.root.ClientModule);
  const { clients, user_manager, client_contact_list } = useSelector(
    state => state.root.ClientModule
  );
  const { user } = useSelector(state => state.root.authUser);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showSubstitutePM, setShowSubstitutePM] = useState(false);
  const [showSubstitutePC, setShowSubstitutePC] = useState(false);
  const [showSubstituteQA, setShowSubstituteQA] = useState(false);
  const [selectedContactPerson, setSelectedContactPerson] = useState(null);
  const [openEmail, setOpenEmail] = useState(false);
  const emailRef = useRef();

  useEffect(() => {
    if (formData?.contact_person) {
      const contactPerson = client_contact_list?.data?.find(
        contact => contact.iContactId == formData.contact_person
      );
      setSelectedContactPerson(contactPerson);
    } else {
      setSelectedContactPerson(null);
    }
  }, [client_contact_list, formData?.contact_person]);

  const handleSubmitMail = async () => {
    if (emailRef.current && emailRef.current.handleSubmit) {
      try {
        const response = await emailRef.current.handleSubmit();
        if (response !== null) {
          dispatch(sendClientMessage({ id: formData?.contact_person, data: response }));
          setOpenEmail(false); // Close modal on success
        }
      } catch (error) {
        console.error("Failed to send email:", error);
      }
    } else {
      console.error("Email ref or handleSubmit not available");
    }
  };

  useEffect(() => {
    if (id) {
      setShowSubstitutePM(formData?.substitute_pm_name != 0);
      setShowSubstitutePC(formData?.substitute_project_coordinator != 0);
      setShowSubstituteQA(formData?.substitute_qa_analyst != 0);
    }
  }, [
    formData?.substitute_pm_name,
    formData?.substitute_project_coordinator,
    formData?.substitute_qa_analyst,
  ]);

  return (
    <>
      <Box sx={{backgroundColor: "#fff", p: 2, mt: 2}}>
        <form onSubmit={handleSave}>
          <Grid container spacing={2} mb={2}>
            <Grid item>
              <Typography variant="body1">
                Project Number:- {id ? formData?.order_no : projectDetail}
                {""}
              </Typography>
            </Grid>
            <Grid item>
              <Typography variant="body1">
                Project Date: {" "}
                {formData?.order_date && !isNaN(new Date(formData.order_date).getTime())
                  ? format(new Date(formData.order_date), "d.M.yyyy | HH:mm")
                  : ""}
              </Typography>
            </Grid>
            {!id && (
              <Grid item sx={{ minWidth: 320, mt: '-10px' }}>
                <DropdownComponent
                  label=""
                  name="scoop_template"
                  value={selectedScoopTemplateId}
                  onChange={handleTemplateChange}
                  options={scoopTemplateOptions}
                  isNotMandatory={true}
                  placeholder="Select scoop template"
                />
              </Grid>
            )}
          </Grid>
          <Grid container spacing={6}>
            {/* Left side */}
            <Grid item xs={12} sm={6} mb={2} sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <Grid2 container alignItems="flex-end" spacing={1}>
                <DropdownComponent
                  sx={{ flex: 1 }}
                  label="Client"
                  name="client"
                  value={formData.client}
                  onChange={handleInputChange}
                  options={clientsOption}
                  // isNotMandatory={true}
                  error={errors.client || ""}
                />
                <IconButton
                  color="primary"
                  disabled={!formData.client}
                  onClick={() => window.open("/viewclient/" + formData.client, "_blank")}
                >
                  <Person />
                </IconButton>
              </Grid2>
              <Grid2 container alignItems="flex-end" spacing={1}>
                <DropdownComponent
                  sx={{ flex: 1 }}
                  label={
                    <LabelWithIcons
                      label="Contact Person"
                      actions={
                        [
                          {
                            icon: <AddCircleOutlineIcon fontSize="small" />,
                            onClick: () => setOpenContactModal(true),
                            disabled: !isClientSelected,
                          },
                        ]
                      }
                    />
                  }
                  name="contact_person"
                  value={formData.contact_person}
                  onChange={handleInputChange}
                  options={clientContactOptions}
                  isNotMandatory={true}
                  error={errors.contact_person || ""}
                  disabled={!isClientSelected && !id}
                />
                <IconButton
                  color="primary"
                  disabled={!formData.contact_person}
                  onClick={() => {
                    dispatch(getEmailTemplate({ userId: user?.iUserId }));
                    setOpenEmail(true);
                  }}
                >
                  <Email />
                </IconButton>
              </Grid2>

              <DropdownComponent
                label={
                  <LabelWithIcons
                    label="Account"
                    actions={[
                      {
                        icon: <AddCircleOutlineIcon fontSize="small" />,
                        onClick: () => setOpenAccountModal(true),
                        disabled: false,
                      },
                    ]}
                  />
                }
                name="account"
                value={formData.account}
                onChange={handleInputChange}
                options={accountOptions}
                // isNotMandatory={true}
                error={errors.account || ""}
              />
              <DropdownComponent
                label="Specialization"
                name="specialization"
                value={formData.specialization}
                onChange={handleInputChange}
                options={specializationOptions}
                isNotMandatory={true}
                error={errors.specialization || ""}
              />
            </Grid>
            {/* Right Side */}
            <Grid item xs={12} sm={6} mb={1} sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <DropdownComponent
                label={
                  id ? (
                    <LabelWithCheckbox
                      label="Project Manager"
                      checkboxLabel="Substitute Project Manager"
                      checked={showSubstitutePM}
                      onChange={e => setShowSubstitutePM(e.target.checked)}
                    />
                  ) : (
                    "Project Manager"
                  )
                }
                name="pm_name"
                value={formData.pm_name}
                onChange={handleInputChange}
                options={usermanagerOptions}
                getOptionDisabled={(option) => option.disabled}
                // isNotMandatory={true}
                error={errors.pm_name || ""}
              />
              {showSubstitutePM && (
                <DropdownComponent
                  label="Substitute Project Manager"
                  name="substitute_pm"
                  value={String(formData.substitute_pm_name)}
                  onChange={handleInputChange}
                  options={usermanagerOptions}
                  getOptionDisabled={(option) => option.disabled}
                  isNotMandatory={true}
                  fullWidth
                  error={errors.substitute_pm || ""}
                />
              )}
              <DropdownComponent
                label={
                  id ? (
                    <LabelWithCheckbox
                      label="Project Coordinator"
                      checkboxLabel="Substitute Project Coordinator"
                      checked={showSubstitutePC}
                      onChange={e => setShowSubstitutePC(e.target.checked)}
                    />
                  ) : (
                    "Project Coordinator"
                  )
                }
                name="project_coordinator"
                value={formData.project_coordinator}
                onChange={handleInputChange}
                options={coordinatorOptions}
                getOptionDisabled={(option) => option.disabled}
                // isNotMandatory={true}
                error={errors.project_coordinator || ""}
              />
              {showSubstitutePC && (
                <DropdownComponent
                  label="Substitute Project Coordinator"
                  name="substitute_project_coordinator"
                  value={String(formData.substitute_project_coordinator)}
                  onChange={handleInputChange}
                  options={coordinatorOptions}
                  getOptionDisabled={(option) => option.disabled}
                  isNotMandatory={true}
                  error={errors.substitute_project_coordinator || ""}
                />
              )}
              <DropdownComponent
                label={
                  id ? (
                    <LabelWithCheckbox
                      label="Quality Assurance Analyst"
                      checkboxLabel="Substitute QA"
                      checked={showSubstituteQA}
                      onChange={e => setShowSubstituteQA(e.target.checked)}
                    />
                  ) : (
                    "Quality Assurance Analyst"
                  )
                }
                name="qa_analyst"
                value={formData.qa_analyst}
                onChange={handleInputChange}
                options={qaOptions}
                getOptionDisabled={(option) => option.disabled}
                isNotMandatory={true}
                error={errors.qa_analyst || ""}
              />
              {showSubstituteQA && (
                <DropdownComponent
                  label="Substitute QA"
                  name="substitute_qa_analyst"
                  value={String(formData.substitute_qa_analyst)}
                  onChange={handleInputChange}
                  options={qaOptions}
                  getOptionDisabled={(option) => option.disabled}
                  isNotMandatory={true}
                  error={errors.substitute_qa_analyst || ""}
                />
              )}

              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <DatePickerComponent
                    name="due_date"
                    label="Due Date"
                    error={errors?.due_date || ""}
                    value={formData?.due_date}
                    onChange={handleInputChange}
                    isMandatory={true}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TimePickerComponent
                    name="due_time"
                    label="Due Time"
                    value={formData?.due_time}
                    onChange={handleInputChange}
                    error={errors?.due_time || ""}
                    isMandatory={true}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </form>
      </Box>

      {openEmail && (
        <PopupModal
          open={openEmail}
          maxWidth="lg"
          title="Mail"
          handleClose={() => setOpenEmail(false)}
          actions={
            <>
              <Btn onClick={handleSubmitMail}>Send Mail</Btn>
              <Btn variant="outlined" onClick={() => setOpenEmail(false)}>
                Cancel
              </Btn>
            </>
          }
        >
          <Typography variant="body1">
            <EmailClient
              ref={emailRef}
              general={true}
              invoiceNumber={selectedContactPerson?.vFirstName}
              email={selectedContactPerson?.vEmail}
            />
          </Typography>
        </PopupModal>
      )}
    </>
  );
};

export default Form;
